import { StationCard } from "./StationCard";

export const StationsList = ({ stations = [], totalResults = 0 }) => {
  return <section className="px-12 py-10">
    <h1 className="font-bold text-4xl text-gray-900 border-l-primary border-l-4 pl-2 flex items-end">
      Gasolineras <span className="text-lg mb-0.5 ml-2">({totalResults}{totalResults >= 500 && "+"})</span>
    </h1>
    {stations.length > 1 && <small className="my-1 block text-sm">Datos del {new Date(stations[0].bulk_insert_id).toLocaleString()}</small>}

    <div
      style={{
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))"
      }}
      className="mt-6 grid gap-x-4 gap-y-6"
    >
      {stations.slice(0, 200).map((station) => <StationCard
        key={station.station_id}
        station={station}
      />)}
    </div>
  </section>
}